import { User } from 'src/types';
import { useMemo } from 'react';

export const useIsTermsAgreed = (userInfo: User) => {
  return useMemo(() => {
    return userInfo?.settings?.terms;
  }, [userInfo]);
};
